<template>
  <TemplatesFullform>
    <slot />
  </TemplatesFullform>
</template>
